// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[0]!../../../../../node_modules/@angular-devkit/build-angular/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[1]!../../../../../node_modules/@angular/material/prebuilt-themes/indigo-pink.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.green-pill {
  background-color: #46a00d;
  color: white;
  padding: 5px;
  border-radius: 8px;
  font-size: 10px;
}

.reassign-btn{
  padding-top: 25px;
}

.app_header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.app_header_left {
  margin-left: 10px;
}

.app_table_search {
  display: inline-block;
}

.search_input {
  width: 100%;
}

.reassign-btn {
  display: flex;
  align-items: center;
}
.clock {
  width: 14px;
  margin-right: 5px;
  margin-top: 5px;
}

.reassign-txt {
  font-weight: bold;
}

.progress-cls {
  background-color: #e4e4e4;
  color:#818181;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.pending-cls, .callback-cls {
  background-color: #fdece9;
  color:#FF633E;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #fdece9;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.cls-reject {
  background-color: #f14741;
  color:white;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #f14741;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.convert-cls, .assign-cls {
  background-color: #00880f;
  color:white;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #00880f;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.cls-accept {
  background-color: #e5f3e7 ;
  color:#00880f;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid  #e5f3e7;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/crm/crm-upsell-eligibity/crm-upsell-eligibity.component.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAOA,gqHAAgqH","sourcesContent":["@import \"~@angular/material/prebuilt-themes/indigo-pink.css\";\n\n.green-pill {\n  background-color: #46a00d;\n  color: white;\n  padding: 5px;\n  border-radius: 8px;\n  font-size: 10px;\n}\n\n.reassign-btn{\n  padding-top: 25px;\n}\n\n.app_header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.app_header_left {\n  margin-left: 10px;\n}\n\n.app_table_search {\n  display: inline-block;\n}\n\n.search_input {\n  width: 100%;\n}\n\n.reassign-btn {\n  display: flex;\n  align-items: center;\n}\n.clock {\n  width: 14px;\n  margin-right: 5px;\n  margin-top: 5px;\n}\n\n.reassign-txt {\n  font-weight: bold;\n}\n\n.progress-cls {\n  background-color: #e4e4e4;\n  color:#818181;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #e4e4e4;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.pending-cls, .callback-cls {\n  background-color: #fdece9;\n  color:#FF633E;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #fdece9;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.cls-reject {\n  background-color: #f14741;\n  color:white;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #f14741;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.convert-cls, .assign-cls {\n  background-color: #00880f;\n  color:white;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #00880f;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.cls-accept {\n  background-color: #e5f3e7 ;\n  color:#00880f;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid  #e5f3e7;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
